module.exports = __webpack_public_path__ + "img/activate-employee.f21a2df2.png";